import React, { useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import styles from './style.module.scss'
import Banner from './Banner'
import TimeLine from './TimeLine'
import Culture from './Culture'
import Mogul from './Mogul'
import MogulMob from './MogulMob'

export default function Company() {
  // 跳转页面指定位置

  const Section1 = useCallback(() => {
    const banners = [
      {
        id: 1,
        img: 'https://tc-cdn.123u.com/official-website/company/company_banner.png',
        titleEn: 'About Huanle Entertainment',
        title: '關於歡樂互娛',
        desc: '歡樂互娛，是行業內少有的連續出爆品的遊戲研發發行公司，2013年成功出品過月流水過億的頁遊爆品《街機三國》，2017年月流水過10億的手游爆品《龍之谷》，2018年《英雄殺》小遊戲DAU突破100萬，2020年研發3年的《仙境傳說RO-爱如初见》上线韩国，高居排行榜前三。公司在动作游戏领域有着丰富的研发经验和深厚的人才储备，同时布局全球化题材的MMO和RTS品类。欢乐产品理念:"宁做100人尖叫的产品，不做1万人叫好的产品"，欢乐出品，必属精品。',
      },
    ]

    return (
      <section id="banner">
        <Banner banners={banners}></Banner>
      </section>
    )
  })

  const Section2 = useCallback(() => {
    const years = [
      {
        year: '2020',
        block1: [
          {
            month: '8月',
            text: '《英雄殺小遊戲》註冊用戶突破5000萬，並作為“小遊戲商業化”成功案例，參與微信公開課小遊戲專場分享。',
          },
          {
            month: '7月',
            text: '《仙境傳說RO》上線韓服，進入谷歌暢銷榜，IOS暢銷榜前3。',
          },
        ],
        block2: [
          {
            month: '5月',
            text: '《美食大戰老鼠2》第一次測試，豐富的世界觀和傳承經典的玩法，深受玩家喜愛。',
          },
        ],
      },
      {
        year: '2019',
        block1: [
          {
            month: '12月',
            text: '《英雄殺小遊戲》，微信收入排行榜TOP3，開創小遊戲新高度。',
          },
        ],
        block2: [
          {
            month: '9月',
            text: '《英雄殺小遊戲》突破100萬DAU。',
          },
        ],
      },
      {
        year: '2018',
        block1: [
          {
            month: '12月',
            text: '《龍之谷手游》海外版《Dragn 巢 M》憑藉在泰國和印度尼西亞的出色表現,榮獲Google Play最佳對戰遊戲推薦。',
          },
          {
            month: '5月',
            text: '《龍之谷手游》進入海外收入榜TOP15。',
          },
        ],
        block2: [
          {
            month: '3月',
            text: '與駿夢遊戲合作，經典IP改編手游《仙境傳說 愛如初見》開始立項研發。',
          },
        ],
      },
      {
        year: '2017',
        block1: [
          {
            month: '2月',
            text: '《龍之谷手游》上線，騰訊最高評級產品，全球流水40億+。',
          },
        ],
        block2: [
          {
            month: '2月',
            text: '《龍之谷手游》首月流水突破9億。',
          },
        ],
      },
      {
        year: '2010-2016',
        block1: [
          {
            month: '2016',
            text: '和巨人網絡合作的《街機三國手游》上線。《美食大戰老鼠》註冊用戶破億。',
          },
          {
            month: '2015',
            text: '首款自發產品《熱血街霸3D》上線。',
          },
          {
            month: '2014',
            text: '《街機之王》上線騰訊QQ空間。',
          },
        ],
        block2: [
          {
            month: '2013',
            text: '橫版格鬥類網頁遊戲《街機三國》上線，極具創新的格鬥玩法，絢麗的特效和極爽快的打擊感使遊戲一出來就備受關注，被稱為第三代網頁遊戲。',
          },
          {
            month: '2010',
            text: '塔防網頁遊戲《美食大戰老鼠》上線，深受休閒遊戲用戶喜愛。',
          },
        ],
      },
      {
        year: '2009',
        block1: [
          {
            month: '7月',
            text: '五個熱血青年，怀揣著夢想，在一個居民樓裡，創辦歡樂互娛，歡樂互娛，歡樂從這裡開始。',
          },
        ],
        block2: [],
      },
    ]
    return (
      <section
        className={`${styles.SectionContainer} ${styles.TimeLineContainer}`}
        id="timeline"
      >
        <div>
          <h3 className={styles.SectionTitle}>發展大事記</h3>
          <p></p>
        </div>
        <section>
          <TimeLine years={years}></TimeLine>
        </section>
      </section>
    )
  })

  const Section3 = useCallback(() => {
    const content = [
      {
        img: 'https://tc-cdn.123u.com/official-website/company/culture1.png',
        title: '利众',
        titleEn: 'Helpfulness',
        desc: ['與人為善', '成年人，Hyoki。', '樂於分享'],
      },
      {
        img: 'https://tc-cdn.123u.com/official-website/company/culture3.png',
        title: '开放包容',
        titleEn: 'Inclusiveness',
        desc: ['尊重不同 | 坦誠表達', '擁抱變化 | 鼓勵嘗試 | 慶祝失敗'],
      },
      {
        img: 'https://tc-cdn.123u.com/official-website/company/culture4.png',
        title: '創新',
        titleEn: 'Innovation',
        desc: ['基於用戶需求，創造新體驗', '保有好奇心', '勇於探索，敢做想做'],
      },
      {
        img: 'https://tc-cdn.123u.com/official-website/company/culture5.png',
        title: '追求極致',
        titleEn: 'Perfection',
        desc: [
          '對用戶體驗，絕不苟且',
          '匠心精神，精益求精',
          '善於學習總結，不斷自我超越',
        ],
      },
      {
        img: 'https://tc-cdn.123u.com/official-website/company/culture2.png',
        title: '團隊合作',
        titleEn: 'Cooperation',
        desc: [
          '一個團隊，一個目標，一條心',
          '團隊贏，個人贏',
          '互相支持，共進退，全負責',
        ],
      },
    ]
    return (
      <section
        className={`${styles.SectionContainer} ${styles.SectionCulture}`}
        id="culture"
      >
        <div>
          <h3>歡樂文化</h3>
          <p></p>
          <div className={styles.SectionCultureText}>
            <h4>願景 使命</h4>
            <p>
              我們的願景是“成為創造極致體驗，啟發心智的全球頂級文化娛樂公司”；我們的使命是“讓更多的人發現人生的美好”；我們價值觀“利眾，開放包容，創新，追求極致，團隊合作”；多年後，當人們談到歡樂互娛時，收到過感動，受到過啟發，收穫過開心，是美好的！
            </p>
          </div>
          <div className={styles.SectionCultureText}>
            <h4>價值觀</h4>
          </div>
          <Culture content={content}></Culture>
        </div>
      </section>
    )
  })

  const Section4 = useCallback(() => {
    const users = [
      {
        id: 1,
        img: 'https://tc-cdn.123u.com/official-website/company/Steven2.png',
        name: 'Steven',
        profession: '歡樂互娛CEO',
        idea: '人人皆有使命，人人都是創作者，每個人都應該像花一樣的綻放一次',
        desc: '毕业于沈阳工业大学计算机系，公司成立十一年以来，成功带领公司出品过《街机三国》页游，《龙之谷》手游，《英雄杀》小游戏，《仙境传说-爱如初见》手游等爆款游戏。内心坚定，有极强的使命感，为玩家提供极致用户体验，启发心智的产品，为公司员工搭建一个实现自我价值、自我超越的环境。',
      },
      {
        id: 3,
        img: 'https://tc-cdn.123u.com/official-website/company/weikun.png',
        name: '大黑',
        profession: '資深製作人',
        idea: '相信熱愛的力量，興趣和樂趣是最好的老師。',
        desc: '入行17年，資深遊戲製作人，擅長策略軍團類游戲，2013年《啪啪三國》系列，國內IOS暢銷榜第8 台灣IOS暢銷榜第2，安卓第1，韓國IOS暢銷榜第1。',
      },
    ]
    return (
      <section className={`${styles.SectionContainer}`} id="mogul">
        <div>
          <h3 className={styles.SectionTitle}>歡樂大咖</h3>
          <p></p>
          <div>
            <Mogul users={users}></Mogul>
            <MogulMob users={users}></MogulMob>
          </div>
        </div>
      </section>
    )
  })

  const Section5 = () => (
    <section
      className={`${styles.SectionContainer} ${styles.TimeLineMobContainer}`}
      id="timeline-mobile"
    >
      <div>
        <h3 className={styles.SectionTitle}>发展大事记</h3>
        <p></p>
        <div>
          <img
            className={`${styles.TimeLineBg}`}
            src="https://tc-cdn.123u.com/official-website/mobile/company/timeline_v2.png"
          >
          </img>
        </div>
      </div>
    </section>
  )

  return (
    <div className={styles.CompanyContainer}>
      <Section1></Section1>
      <Section2></Section2>
      <Section3></Section3>
      <Section4></Section4>
      <Section5></Section5>
    </div>
  )
}
